<div class="ui-grid ui-grid-responsive ui-fluid formcontainer" *ngIf="partnerRelationship"> 
          
    <div class="formgroup">
        <div class="ui-grid-row">
            <div class="ui-grid-col-6">
                <label for="partnerstatus">Partner Status</label><br>
            </div>
        </div>
        <div class="ui-grid-row">   
            <div class="ui-grid-col-6">
				<p-dropdown [options]="partnerStatus" optionLabel="name" [(ngModel)]="currentPartnerStatus" (onChange)="partnerStatusChange()" *ngIf="!readOnly"></p-dropdown>
				<span *ngIf="readOnly && currentPartnerStatus">{{currentPartnerStatus.name}}</span>
            </div>
        </div>
    </div>
    <div class="formgroup">
        <div class="ui-grid-row">
            <div class="ui-grid-col-6">
                <label for="partnertype">Partner Type</label><br>
            </div>
        </div>
        <div class="ui-grid-row">
            <div class="ui-grid-col-6">
                {{partnerRelationship.RelationshipType.Description}}
            </div>
        </div>
    </div>

    <div class="formgroup">
        <div class="ui-grid-row">
            <div class="ui-grid-col-6">
                <label for="partner">Partner</label>
            </div>
        </div>
        <div class="ui-grid-row">
            <div class="ui-grid-col-6">
                <input type="text" pInputText [(ngModel)]="partnerRelationship.ChildCompany.Name" (onChange)="ParterNameChange()" name="partnerName" id="partnerName" *ngIf="!readOnly" />
                <span *ngIf="readOnly">{{partnerRelationship.ChildCompany.Name}}</span>
            </div>
        </div>
    </div>
    <div class="formgroup" *ngIf="!readOnly">
        <div class="ui-grid-row">
            <div class="ui-grid-col-6">
            <div class="ui-inputgroup">
                <span class="ui-inputgroup-addon"><i class="pi pi-search"></i></span>
                <input type="text" pInputText placeholder="Search Available Groups" size="40" [(ngModel)]="searchInput" name="searchInput" id="searchInput" (keyup)="searchTextInput($event.target.value)">
                <i class="pi pi-info-circle" style="font-size:24px" pTooltip="Enter search criteria to filter the list of available Asset IDs to assign to the Partner selected"></i>
            </div>
            </div>
        </div>
    </div>
    <div class="formgroup">
        <div class="ui-grid-row">
            <div class="ui-grid-col-12">
                <label for="partner">Master Asset Group <span class="custom-required">*</span></label>
            </div>
        </div>
        <div class="ui-grid-row">
            <div class="ui-grid-col-12">
				<app-picklist-asset-group [availableGroup] = availableGroup [selectedGroup]="selectedGroup" (onAssetGroupChange)="masterGroupChange($event)" [loading]= "assetGroupLoading" [showSourceFilter]="false" [showTargetFilter]="true" *ngIf="!readOnly"></app-picklist-asset-group>
				<span *ngIf="readOnly && assetGroupItemId">{{assetGroupItemId.join(', ')}}</span>
            </div>
        </div>
        <span class="custom-error" *ngIf="assetIdCount > 200 && !readOnly">Showing first 200 results. Refine Search to see full list of Available Asset IDs</span>
        <span *ngIf="selectedGroup?.length <= 0 && !readOnly" class="custom-error">Please select alteast one Master Asset Group</span>
  </div>  

   <div class="formgroup">
    <div class="ui-grid-row">
        <div class="ui-grid-col-12">
          <label for="Privileges">Master Admin Privileges<span class="custom-required">*</span></label>
        </div>
    </div>
    <div class="ui-grid-row">
      <app-privilege-dropdown
        [privilegeGroup]="relationshipTypePrivileges" 
        [preSelectedPrivilege]="privilegesAssigned"
        [maxSelectedLabels]="1"
        [group]=true
        defaultLabel="Select Privilege" 
        filterPlaceHolder=""
        (onChange)="privilegeChange($event)"
        *ngIf="!readOnly">
      </app-privilege-dropdown>
      <span *ngIf="readOnly && relationshipTypePrivileges.length > 0">{{privilegeList(privilegesAssigned)}}</span>
       <i class="pi pi-info-circle" style="font-size:24px" pTooltip="Privileges control what each user is able to see and do in the EQ Connect Portal. This Master set creates an Admin privilege group which the Primary Contact will be part of.  If given the Add/Edit Partner Users privilege, the Admins can assign all or a subset of the Master set to each additional user."></i>
        <span [ngClass]="{'check-circle-gray': selectedItemsNow?.length <=0,
                'check-circle-green': selectedItemsNow?.length > 0}" *ngIf="!readOnly">
            <i class="pi pi-check-circle"></i>
        </span>
    </div> 
     <span *ngIf="selectedItemsNow?.length <=0 && !readOnly" class="custom-error">Master Admin Privileges are required</span>
</div>

  <div class="formgroup">
    <div class="ui-grid-row">
        <div class="ui-grid-col-6">
            <label for="primarycontact">Primary Contact</label>
        </div>
    </div>
    <div class="ui-grid-row">
        <div class="ui-grid-col-6">
			<p-dropdown [options]="primaryContactPersons" optionLabel="Email" [(ngModel)]="primaryContactSelected" (onChange)="primaryContactChange()" *ngIf="!readOnly"></p-dropdown>
			<span *ngIf="readOnly && primaryContactSelected">{{primaryContactSelected.FullName ? primaryContactSelected.FullName : primaryContactSelected.Email}}</span>
        </div>
    </div>
  </div>
</div>